module.exports = __webpack_public_path__ + "static/media/e7.accd07e5.jpg";